"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
function isProjectMember(object) {
    return checkProjectMember(object).fulfilled;
}
exports.isProjectMember = isProjectMember;
function checkProjectMember(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return __1.check(object, __1.hasString("id"), __1.hasChoice("status", ["active", "archived", "inactive"]), __1.hasString("name"), __1.hasNumber("lastOpenedChatTimestamp"), __1.hasBoolean("hasUnreadMessages"), __1.hasChoice("externalMemberRole", ["EXTERNAL", "EXTERNAL_SUPERVISOR"]).optional()).withOptions(options).explain();
}
exports.checkProjectMember = checkProjectMember;
//# sourceMappingURL=ProjectMember.js.map